import { useState } from "react";
import TableMaquinas from "./components/TableMaquinas";
import Divider from "../../../components/Tools/Basics/Divider";
import DepositosModal from "./components/Depositos/DepositosModal";
import CustomBtn from "../../../components/Tools/Basics/CustomBtn";

const Maquinas = () => {
  const [showDepositos, setShowDepositos] = useState(false);

  return (
    <div className="custom-container">
      <div className="d-flex justify-content-between align-items-center">
        <h2>
          <b>Maquinas Terminales y Servicios</b>
        </h2>
        <CustomBtn
          type="plus_table_header"
          onClick={() => setShowDepositos(true)}
          text=" Gestionar Depósitos"
        />
      </div>
      <Divider />
      <TableMaquinas />

      <DepositosModal
        show={showDepositos}
        handleClose={() => setShowDepositos(false)}
      />
    </div>
  );
};

export default Maquinas;
